"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlpSeedFromBlockHash = exports.getPseudorandomPart = exports.shiftRightAndCast = exports.getRandomAlpSeed = exports.getAlpData = exports.getArtCounts = exports.ImageData = void 0;
const solidity_1 = require("@ethersproject/solidity");
const bignumber_1 = require("@ethersproject/bignumber");
const image_data_json_1 = __importDefault(require("./image-data.json"));
/** The art bundled with this package, synced from the chain by `yarn sync-traits` */
exports.ImageData = image_data_json_1.default;
/**
 * Count the traits in some art
 * @param art The art, the bundled `ImageData` by default
 */
const getArtCounts = (art = exports.ImageData) => ({
    backgrounds: art.bgcolors.length,
    bodies: art.images.bodies.length,
    accessories: art.images.accessories.length,
    heads: art.images.heads.length,
    glasses: art.images.glasses.length,
});
exports.getArtCounts = getArtCounts;
/**
 * Get encoded part and background information using a Alp seed
 * @param seed The Alp seed
 * @param art The art to draw from, the bundled `ImageData` by default
 */
const getAlpData = (seed, art = exports.ImageData) => {
    const { bodies, accessories, heads, glasses } = art.images;
    return {
        parts: [
            bodies[seed.body],
            accessories[seed.accessory],
            heads[seed.head],
            glasses[seed.glasses],
        ],
        background: art.bgcolors[seed.background],
    };
};
exports.getAlpData = getAlpData;
/**
 * Generate a random Alp seed
 * @param art The art to pick traits from, the bundled `ImageData` by default
 */
const getRandomAlpSeed = (art = exports.ImageData) => {
    const counts = (0, exports.getArtCounts)(art);
    return {
        background: Math.floor(Math.random() * counts.backgrounds),
        body: Math.floor(Math.random() * counts.bodies),
        accessory: Math.floor(Math.random() * counts.accessories),
        head: Math.floor(Math.random() * counts.heads),
        glasses: Math.floor(Math.random() * counts.glasses),
    };
};
exports.getRandomAlpSeed = getRandomAlpSeed;
/**
 * Emulate bitwise right shift and uint cast
 * @param value A Big Number
 * @param shiftAmount The amount to right shift
 * @param uintSize The uint bit size to cast to
 */
const shiftRightAndCast = (value, shiftAmount, uintSize) => {
    const shifted = bignumber_1.BigNumber.from(value).shr(shiftAmount).toHexString();
    return `0x${shifted.substring(shifted.length - uintSize / 4)}`;
};
exports.shiftRightAndCast = shiftRightAndCast;
/**
 * Emulates the AlpsSeeder.sol methodology for pseudorandomly selecting a part
 * @param pseudorandomness Hex representation of a number
 * @param partCount The number of parts to pseudorandomly choose from
 * @param shiftAmount The amount to right shift
 * @param uintSize The size of the unsigned integer
 */
const getPseudorandomPart = (pseudorandomness, partCount, shiftAmount, uintSize = 48) => {
    const hex = (0, exports.shiftRightAndCast)(pseudorandomness, shiftAmount, uintSize);
    return bignumber_1.BigNumber.from(hex).mod(partCount).toNumber();
};
exports.getPseudorandomPart = getPseudorandomPart;
/**
 * Emulates the AlpsSeeder.sol methodology for generating a Alp seed
 * @param alpId The Alp tokenId used to create pseudorandomness
 * @param blockHash The block hash use to create pseudorandomness
 * @param counts The trait counts the seeder reads from the descriptor, the bundled art's by default
 */
const getAlpSeedFromBlockHash = (alpId, blockHash, counts = (0, exports.getArtCounts)(exports.ImageData)) => {
    const pseudorandomness = (0, solidity_1.keccak256)(['bytes32', 'uint256'], [blockHash, alpId]);
    return {
        background: (0, exports.getPseudorandomPart)(pseudorandomness, counts.backgrounds, 0),
        body: (0, exports.getPseudorandomPart)(pseudorandomness, counts.bodies, 48),
        accessory: (0, exports.getPseudorandomPart)(pseudorandomness, counts.accessories, 96),
        head: (0, exports.getPseudorandomPart)(pseudorandomness, counts.heads, 144),
        glasses: (0, exports.getPseudorandomPart)(pseudorandomness, counts.glasses, 192),
    };
};
exports.getAlpSeedFromBlockHash = getAlpSeedFromBlockHash;
